window.addEventListener("DOMContentLoaded", function () {
    const buttons = document.querySelectorAll('.single-project .main-content a.project-link');
    
    if(buttons.length) {
        const target = document.querySelector('.entry-content');
        const team = target?.querySelector('.team-members');
        if (target && team) {
            target.insertBefore(buttons[0], team);
        }
    }
})
